"use client";
import SvgDahlesSymbol from "./dahles_symbol.svg.js";
import SvgDahlesWordmark from "./dahles_wordmark.svg.js";
const dahles = {
  key: "dahles",
  symbol: SvgDahlesSymbol,
  wordmark: SvgDahlesWordmark
};
export {
  dahles
};
